import type { StateCreator } from 'zustand';

import type { Unidade } from '@infor/core/models/unidade';

export type UnidadeSlice = {
  unidades: Unidade[];
  unidadeCorrente: Unidade | null;
  setUnidades: (unidades: Unidade[]) => void;
  setUnidadeCorrente: (unidadeId: number | null) => void;
};

export const createUnidadeSlice: StateCreator<
  UnidadeSlice,
  [],
  [],
  UnidadeSlice
> = (set) => ({
  unidades: [],
  unidadeCorrente: null,
  setUnidades: (unidades) => set((state) => ({ ...state, unidades })),
  setUnidadeCorrente: (unidadeId) =>
    set((state) => {
      if (unidadeId === null) {
        return { ...state, unidadeCorrente: null };
      }

      const unidCorrente = state.unidades.find(
        (u) => u.id === Number(unidadeId)
      );

      if (!unidCorrente) {
        return state;
      }

      return { ...state, unidadeCorrente: unidCorrente };
    }),
});
